import React from 'react';
import ProfileLayout from '@/components/account/layout/ProfileLayout';
import ProfileContentLayout from '@/components/account/layout/ProfileContentLayout';
import ProfileMainContent from '@/components/account/mainContent/ProfileMainContent';
import ProfileSidebar from '@/components/account/profile-sidebar';

const Profile = () => {
  return (
    <ProfileLayout>
      <ProfileContentLayout
        mainContent={<ProfileMainContent />}
        sidebar={<ProfileSidebar />}
      />
    </ProfileLayout>
  );
};

export default Profile;
